export default __webpack_public_path__ + "static/media/about-us-icon-quotation-mark.939ebbcf.svg";